"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signupConfirmConstraints = void 0;
const signupConfirmConstraints = exports.signupConfirmConstraints = {
  otp: {
    presence: {
      empty: false
    },
    length: {
      is: 6
    }
  }
};